import React from 'react';
import { InfoOutline } from '@yme/assets/icons';
import { Tooltip, TooltipPlacement } from '@yme/atoms/tooltip';
import { useTouchOnly } from '@yme/hooks/useTouchOnly';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { FinanceTextStyled, SVGIconInfo } from './styled';
export function ProductYouFinanceInfo({ priceExtraInfo, priceExtraInfoTooltip, }) {
    const isTouchOnly = useTouchOnly();
    const { isMobileView } = useWindowSize();
    const supportHover = !isTouchOnly;
    return (React.createElement(FlexWrapper, { gap: INDENT.xxxxs, mt: INDENT.sm, alignItems: "center" },
        React.createElement(FinanceTextStyled, null, priceExtraInfo),
        priceExtraInfoTooltip && (React.createElement(Tooltip, { title: priceExtraInfoTooltip, placement: isMobileView ? TooltipPlacement.BELOW_RIGHT : undefined, hasEnableClickListener: !supportHover, hasEnableHoverListener: supportHover },
            React.createElement(SVGIconInfo, { type: InfoOutline })))));
}
ProductYouFinanceInfo.displayName = 'ProductYouFinanceInfo_Component';
